import axios from 'axios';
import Cookies from 'js-cookie';
import { CONFIG } from '@/config/Config';

export interface User {
  id: number;
  name: string;
  email: string;
  avatarUrl: string;
  international: boolean;
}

export interface UserDetails {
  id: number;
  name: string;
  email: string;
  userGroup: string;
  readOnly: boolean;
  avatarUrl: string;
  international: boolean;
}

export interface AccountResponse {
  id: number;
  name: string;
  userGroup: string;
}

export interface CompanyResponse {
  useUniverseCreditSystem?: boolean;
}

class UserService {
  private createAuthenticatedAxios() {
    const axiosInstance = axios.create();
    
    axiosInstance.interceptors.request.use((config) => {
      const token = Cookies.get(CONFIG.AUTH.SSID);

      if (token) {
        config.headers[CONFIG.AUTH.SSID] = token;
      }
      return config;
    });

    return axiosInstance;
  }

  async getUserMe(): Promise<User> {
    const gateway = CONFIG.getGatewayUrl();
    const version = CONFIG.getVersion();

    const url = `${gateway}upms-legacy/${version}/user/me`;
    
    const axiosInstance = this.createAuthenticatedAxios();
    const response = await axiosInstance.get(url);
    
    return response.data;
  }

  async getAccountEditors(accountId: string): Promise<UserDetails[]> {
    const gateway = CONFIG.getGatewayUrl();
    const version = CONFIG.getVersion();

    const url = `${gateway}upms-legacy/${version}/user/account/editors`;

    const payload = {
      accountId: accountId,
    };
    
    const axiosInstance = this.createAuthenticatedAxios();
    const response = await axiosInstance.get(url, { params: payload });
    
    return response.data;
  }

  async getAccountById(accountId: string): Promise<AccountResponse> {
    const gateway = CONFIG.getGatewayUrl();
    const version = CONFIG.getVersion();
    const url = `${gateway}upms-legacy/${version}/account/v2/${accountId}`;

    const axiosInstance = this.createAuthenticatedAxios();
    const response = await axiosInstance.get<AccountResponse>(url, {
      headers: { accept: 'application/json' },
    });

    return response.data;
  }

  async getCompany(name: string): Promise<CompanyResponse> {
    const gateway = CONFIG.getGatewayUrl();
    const version = CONFIG.getVersion();
    const url = `${gateway}upms-legacy/${version}/company`;

    const axiosInstance = this.createAuthenticatedAxios();
    const response = await axiosInstance.get<CompanyResponse>(url, {
      params: { name },
      headers: { accept: 'application/json' },
    });

    return response.data;
  }
}

const userService = new UserService();
export default userService;